import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect,
} from "react";
import "../ficha-master.css";
import { set, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Swal from "sweetalert2";
import FormInput from "../../../../nuup/componentes/Forms/FormInput.jsx";
import Api from "../../../../api/global.service.js";
import BlockUi from 'react-block-ui';

const ModalFichaCoopActualizaForm = forwardRef((props, ref) => {
  const [show, setShow] = useState(false);
  const [blocking, setBlocking] = useState(false);
  const [error, setError] = useState("");
  const [validationErrors, setValidationErrors] = useState(null);
  const [ficha, setFicha] = useState();
  const [fichaMaster, setFichaMaster] = useState();
  const [archivo, setArchivo] = useState();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    clearErrors,
  } = useForm({
    resolver: async (data, context, options) => {
      return yupResolver(schema)(data, context, options);
    },
    mode: "onBlur",
    defaultValues: {
      archivo: "",
    },
  });

  const MAX_FILE_SIZE = 1024000;

  const validFileExtensions = { xlsForm: ["xls", "xlsx"] };

  function isValidFileType(fileName, fileType) {
    return (
      fileName &&
      validFileExtensions[fileType].indexOf(fileName.split(".").pop()) > -1
    );
  }

  const schema = yup.object().shape({
    archivo: yup
      .mixed()
      .required("Required")
      .test("is-valid-type", "***Se espera un archivo xls ó xlsx", (value) =>
        isValidFileType(value && value[0]?.name?.toLowerCase(), "xlsForm")
      )
      .test(
        "is-valid-size",
        "El tamaño máximo de archivo debe ser 1 MB",
        (value) => value && value[0]?.size <= MAX_FILE_SIZE
      ),
  });

  //To call outside
  useImperativeHandle(ref, () => ({
    show: showHandler,
    setData: (data) => setFicha(data),
    setDataMaster: (data) => setFichaMaster(data),
  }));

  const showHandler = () => {
    setShow(true);
  };

  const closeHandler = () => {
    props.onFinish();
    setShow(false);
  };


  const VALIDATION_CATEGORY_LABELS = {
    variable_references: "Referencias de variables",
    group_pairs: "Pares de grupos",
    duplicate_names: "Nombres duplicados",
    empty_names: "Nombres vacíos",
    choice_lists: "Listas de opciones",
    label_required: "Etiqueta requerida",
  };

  const onSubmit = async (values) => {
    try {
      setBlocking(true);
      setError();
      setValidationErrors(null);
      const formData = new FormData();
      for (var key in values) {
        let v = values[key];
        formData.append(key, v);
      }

      formData.append("archivo", archivo);

      Api.createMultiPart("ficha/kobo/coop/actualizaForm/" + ficha.id_kobo_ficha_principal, formData)
        .then((response) => {
          setBlocking(false);
          closeHandler();
        })
        .catch((e) => {
          setBlocking(false);
          if (e.response?.status === 422 && e.response?.data?.data && Object.keys(e.response.data.data).length > 0) {
            setError(e.response.data.message);
            setValidationErrors(e.response.data.data);
          } else {
            setError(e.response?.data?.message || "Error al guardar");
          }
        });

    } catch (e) {
      setBlocking(false);
      await Swal.fire({
        icon: "error",
        title: "",
        text: e.response.data.message,
      });
    }
  };


  const handleFileChange = (event) => {
    setError();
    setValidationErrors(null);
    const file = event.target.files[0];
    if (file) {
      setArchivo(file);
    } else {
      setArchivo(null);
    }
  }

  return (
    <div
      className="modal"
      style={{
        display: show ? "block" : "none",
        backgroundColor: "rgba(0,0,0,0.2)",
      }}
    >
      <div className="modal-dialog" style={{ width: 550,overflowY : 'auto', maxHeight: '80vh', display : 'block' }}>
        <div className="modal-content" style={{ height: "100%" }}>
          <div className="modal-header" style={{ flex: "inherit" }}>
            <h4 style={{color : 'black'}}>{ficha?.nombre}</h4>
            <button
              onClick={() => closeHandler()}
              type="button"
              className="btn"
              style={{ borderRadius: "20px 20px 20px 20px" }}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>

          <div className="modal-body">
            {error && (
              <p className="ficha-error">
                <span style={{color:"white"}}>{error}</span>
              </p>
            )}
            {validationErrors && (
              <div style={{ marginBottom: 12 }}>
                {Object.entries(validationErrors).map(([category, items]) => (
                  <div key={category} style={{ marginBottom: 10 }}>
                    <strong style={{ display: "block", marginBottom: 4, color: "#842029" }}>
                      {VALIDATION_CATEGORY_LABELS[category] || category}
                    </strong>
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                      {items.map((item, idx) => (
                        <li key={idx} style={{ fontSize: 13, color: "#333", marginBottom: 2 }}>
                          <span style={{ fontWeight: 600 }}>Fila {item.row}:</span> {item.detail}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            )}
          <BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>

            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="m-b-15">
                <FormInput
                  id="archivo"
                  type="file"
                  name="archivo"
                  label=""
                  placeholder="Archivo"
                  error={errors.archivo}
                  register={register}
                  onChange={handleFileChange}
                />
              </div>

              {!blocking && (
                <button
                  type="submit"
                  className="btn btn-sirio"
                  style={{ borderRadius: "20px 20px 20px 20px" }}
                >
                  <i className="fa fa-save"></i> Guardar
                </button>
              )}
            </form>
            </BlockUi>
          </div>
      </div>
      </div>
    </div>
  );
});

export default ModalFichaCoopActualizaForm;
